<script setup lang="ts">
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { parseISO, format } from "date-fns";
import { isInvalid } from "@/utility/date";
import { StatisticsShowType } from "@/interface/order";
import {
  OperationMonthReport,
  OperationDayReport,
} from "@/api/driverApi/records";
import { OperationReportModel } from "@/interface/report";

const route = useRoute();
const router = useRouter();

const type = route.params.type as StatisticsShowType;
const date = parseISO(route.params.date as string);
const isinvalid = isInvalid(date);
const reportData = ref<OperationReportModel | null>(null);

if (!isinvalid) router.go(-1);

const fetchData = async () => {
  const xhr =
    type === StatisticsShowType.Month
      ? OperationMonthReport(date)
      : OperationDayReport(date);
  const { data } = await xhr;
  reportData.value = data;
};

const DayStringFormat = (date: Date) => {
  return format(date, "yyyy 年 MM 月 dd 日");
};

await fetchData();
</script>

<template>
  <div class="container py-4">
    <div
      v-if="type == StatisticsShowType.Day"
      class="mb-4 p-2 rounded-pill bg-secondary bg-opacity-10 text-center fs-4 fw-bold text-secondary">
      {{ DayStringFormat(date) }}
    </div>

    <!-- 營運統計 -->
    <h4 class="fw-bold text-secondary">營運統計</h4>

    <hr class="my-2 hr-dashed" />

    <div class="row g-2 statistics-item">
      <div class="col border-end border-right-dashed">
        <div class="statistics-item h-100 span-vertical-between">
          <span class="text-secondary text-spacing-3">預約單</span>
          <div class="text-end">
            <span class="display-3 text-primary">
              {{ reportData?.BookingFinishTotal ?? "-" }}
            </span>
            <span
              class="text-secondary d-inline-block rounded-pill bg-primary-light ms-1"
              >趟</span
            >
          </div>
        </div>
      </div>
      <div class="col">
        <div class="statistics-item h-100 span-vertical-between">
          <span class="text-secondary text-spacing-3">即時叫車</span>
          <div class="text-end">
            <span class="amount text-primary">
              {{ reportData?.InstantFinishTotal ?? "-" }}
            </span>
            <span
              class="text-secondary d-inline-block rounded-pill bg-primary-light ms-1"
              >趟</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="">
      <div class="statistics-item span-between">
        <span class="text-secondary text-spacing-3">總趟數</span>
        <span class="amount text-primary">{{ reportData?.TripsTotal }}</span>
      </div>
      <div class="statistics-item span-between">
        <span class="text-secondary text-spacing-3">優惠券<br />使用次數</span>
        <span class="amount text-primary">
          {{ reportData?.BonusTripsTotal ?? "-" }}
        </span>
      </div>
      <div class="statistics-item span-between">
        <span class="text-secondary text-spacing-3">跳表金額</span>
        <span class="amount text-primary">
          {{ reportData?.FareCostTotal ?? "-" }}
        </span>
      </div>
      <div class="statistics-item span-between">
        <span class="text-secondary text-spacing-3">優惠券<br />金額</span>
        <span class="amount text-primary">
          {{ reportData?.BonusPriceTotal ?? "-" }}
        </span>
      </div>
    </div>

    <hr class="my-2 hr-dashed" />
  </div>
</template>
